// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d09170e","465":"4121995a"}[chunkId] + ".chunk.js";
};